// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lWZmDzyLReIdl23ZNfoC {
  background-color: var(--CT-colors-background-root);
  padding: 0px;
}

.f8oYz5X7nA0f0qxcUFWN {
  background-color: var(--CT-colors-background-main-content);
}

.tEM_Lba7s1VZzLCn6u_u {
  background-color: var(--CT-colors-black) !important;
}

[data-mantine-color-scheme='dark'] .tEM_Lba7s1VZzLCn6u_u {
  background-color: var(--CT-colors-dark-6) !important;
}

.tEM_Lba7s1VZzLCn6u_u {
  color: var(--mantine-color-white) !important;
}

.tEM_Lba7s1VZzLCn6u_u:hover {
    background-color: var(--CT-colors-dark-7) !important;
  }

[data-mantine-color-scheme='dark'] .tEM_Lba7s1VZzLCn6u_u:hover {
    background-color: var(--CT-colors-dark-5) !important;
}

.au2NhcYT3zJchez10zk_ {
  max-width: 275px;
  width: 100%;
  align-self: center;
  background-color: #000;
}

.au2NhcYT3zJchez10zk_:hover {
    background-color: var(--CT-colors-dark-7) !important;
  }

[data-mantine-color-scheme='dark'] .au2NhcYT3zJchez10zk_:hover {
    background-color: #090909 !important;
}

.UdC8_ky0FD4etCoyJP2U {
  max-height: fit-content !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/universalStyles.module.css","<no source>"],"names":[],"mappings":"AAAA;EACE,kDAAkD;EAClD,YAAY;AACd;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,mDAAwF;AAM1F;;AChBA;EDUE;CCVF;;AAAA;EDWE;CCXF;;ADaE;IACE,oDAAyF;EAC3F;;ACfF;IDcI;CCdJ;;ADkBA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,sBAAsB;AAIxB;;AAHE;IACE,oDAAyE;EAC3E;;ACzBF;IDwBI;CCxBJ;;AD4BA;EACE,kCAAkC;AACpC","sourcesContent":[".root {\n  background-color: var(--CT-colors-background-root);\n  padding: 0px;\n}\n\n.mainContent {\n  background-color: var(--CT-colors-background-main-content);\n}\n\n.blackButton {\n  background-color: light-dark(var(--CT-colors-black), var(--CT-colors-dark-6)) !important;\n  color: var(--mantine-color-white) !important;\n\n  &:hover {\n    background-color: light-dark(var(--CT-colors-dark-7), var(--CT-colors-dark-5)) !important;\n  }\n}\n\n.blackButtonOnPaper {\n  max-width: 275px;\n  width: 100%;\n  align-self: center;\n  background-color: #000;\n  &:hover {\n    background-color: light-dark(var(--CT-colors-dark-7), #090909) !important;\n  }\n}\n\n.notification {\n  max-height: fit-content !important;\n}\n",null],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `lWZmDzyLReIdl23ZNfoC`,
	"mainContent": `f8oYz5X7nA0f0qxcUFWN`,
	"blackButton": `tEM_Lba7s1VZzLCn6u_u`,
	"blackButtonOnPaper": `au2NhcYT3zJchez10zk_`,
	"notification": `UdC8_ky0FD4etCoyJP2U`
};
export default ___CSS_LOADER_EXPORT___;
